module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-coupon-list row column"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('segment-reveal', {
    attrs: {
      "segment": null
    },
    on: {
      "itemUpdated": _vm.loadSegments
    }
  })], 1), (_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.segments.length && !_vm.loading) ? [_c('div', {
    staticClass: "component-backoffice-category-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.segments), function(segment, index) {
    return _c('div', {
      staticClass: "column small-12 large-4 category",
      class: {
        active: _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.setSearch(index)
        }
      }
    }, [_c('div', {
      staticClass: "inner-content card text-center"
    }, [_c('div', {
      staticClass: "row p-1"
    }, [(_vm.activeIndex === index) ? _c('div', {
      staticClass: "column shrink"
    }, [_c('dropdown', {
      attrs: {
        "icon": 'fa fa-ellipsis-v fa-2x action',
        "position": 'bottom'
      }
    }, [_c('div', {
      staticClass: "dropdown-buttons"
    }, [(_vm.activeIndex === index) ? _c('segment-reveal', {
      attrs: {
        "segment": segment
      }
    }) : _vm._e(), _c('segment-attributes-reveal', {
      attrs: {
        "segment": segment
      }
    }), _c('segment-slots-reveal', {
      attrs: {
        "segment": segment
      }
    })], 1)])], 1) : _vm._e(), _c('div', {
      staticClass: "column small-8",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('p', [_vm._v("SG" + _vm._s(segment.id) + " " + _vm._s(segment.name) + "  ")])]), _c('div', {
      staticClass: "column shrink"
    })]), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [(segment.attributes.length) ? _c('hr') : _vm._e(), _vm._l((segment.attributes), function(attribute) {
      return _c('span', [_vm._v(_vm._s(attribute.name) + ": " + _vm._s(attribute.value) + " ")])
    })], 2)])])])
  }), 0)]), (_vm.segments[_vm.activeIndex]) ? [_c('hr'), _c('h2', [_vm._v("Segment rates")]), (_vm.segments[_vm.activeIndex]) ? _c('SegmentRateReveal', {
    key: _vm.segments[_vm.activeIndex].id,
    attrs: {
      "segment": _vm.segments[_vm.activeIndex]
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$refs.list.loadData(1)
      }
    }
  }) : _vm._e(), (_vm.segments.length) ? _c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": false,
      "search": _vm.search
    }
  }) : _vm._e()] : _vm._e()] : (_vm.segments.length == 0 && !_vm.loading) ? [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("No segments")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b921bf4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/SegmentList.vue
// module id = 2510
// module chunks = 1